<div class="input-radio">
  <label class="label-input" *ngIf="showLabel">
    <span *ngIf="showLabel"> {{ label | translate }}</span>
    <span *ngIf="checkRequire()" class="p-errors" style="color: red; margin-left: 3px">*</span></label
  >
  <div class="group-radio-item" [style.flex-direction]="styleOption === 'horizontal' ? 'row' : 'column'">
    <p-radioButton
      *ngFor="let option of options"
      [formControl]="control"
      label="{{ option[optionLabel] ?? option | translate }}"
      [style.margin-right]="'6px'"
      [value]="option[optionValue] ?? option"
      (onClick)="emitChange($event)"
    ></p-radioButton>
  </div>
  <div class="relative b-errors">
    <ng-container *ngIf="errors">
      <small class="p-error error-msg block fadeinup animation-duration-300">
        <span class="block">{{ getError().key | translate: getError().required }}</span>
      </small>
    </ng-container>
  </div>
</div>
